<template>
  <div class="posts-container">
    <!-- Loading State -->
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-2">Loading...</p>
    </div>

    <!-- Empty State -->
    <div v-else-if="posts.length === 0" class="text-center py-5">
      <i class="bi bi-chat-dots text-muted" style="font-size: 3rem;"></i>
      <h5 class="mt-3 text-muted">No Posts Yet</h5>
      <p class="text-muted">Be the first to share!</p>
      <button 
        v-if="isAuthenticated"
        class="btn btn-primary"
        @click="$emit('create-post')"
      >
        Create First Post
      </button>
    </div>

    <!-- Posts List -->
    <div v-else>
      <PostCard
        v-for="post in posts"
        :key="post.id"
        :post="post"
        :user="user"
        :is-authenticated="isAuthenticated"
        :get-topic-name="getTopicName"
        :format-time="formatTime"
        @like-post="$emit('like-post', $event)"
        @show-comments="$emit('show-comments', $event)"
        @show-rating="$emit('show-rating', $event)"
        @add-comment="$emit('add-comment', $event)"
      />
    </div>
  </div>
</template>

<script>
import PostCard from './PostCard.vue'

export default {
  name: 'PostsList',
  components: {
    PostCard
  },
  props: {
    posts: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      default: null
    },
    getTopicName: {
      type: Function,
      required: true
    },
    formatTime: {
      type: Function,
      required: true
    }
  },
  emits: [
    'create-post',
    'like-post', 
    'show-comments',
    'show-rating',
    'add-comment'
  ]
}
</script>

<style scoped>
.posts-container {
  min-height: 300px;
}
</style>